<app-header [label]="page_name | plural"></app-header>
<div class="flex bg-white gap-4 items-center justify-between p-4 border-b border-gray-300">
    <app-search-input #searchbar></app-search-input>
    <app-dropdown-upload-button [page_name]="page_name" (bulkUpload)="bulk_modal.open()" (singleUpload)="open_form_modal()"> </app-dropdown-upload-button>
</div>
<app-ag-grid-list [list]="items" [colDefs]="country_cols" [itemName]="page_name" (fetch_new_list)="get_list($event)" (bulkDelete)="bulk_delete($event)">
</app-ag-grid-list>
<app-confirmation-popup #confirmation_delete_modal label="Delete {{page_name}}?" [delete_icon]="true" cancelText="No" confirmColor="bg-[#FA2912] text-[#FFFFFF]" confirmText="Yes" [is_mandatory]="true" (confirm_modal_clicked)="delete_program()" (close_modal_clicked)="confirmation_delete_modal.close()">
    Are you sure you want to Permanently delete the selected record ? This cannot be undone
</app-confirmation-popup>
<app-confirmation-popup #confirmation_disabled_modal [enable_icon]="selected_program_ids.is_active == true ? false : true" [disabled_icon]="selected_program_ids.is_active == false ? false : true" confirmColor="bg-[#FA2912] text-[#FFFFFF]" [is_mandatory]="true" (confirm_modal_clicked)="update_country(selected_program_ids.is_active)" (close_modal_clicked)="confirmation_delete_modal.close()">
    Are you sure you want to {{selected_program_ids.is_active == true? "Disable" :"Enable"}} {{page_name}}
</app-confirmation-popup>
<app-modal #form_modal [label]="`${selected_program_ids.id ? 'Update' : 'Add'} ${page_name}`">
    <form [formGroup]="form">
        <div class="py-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
            <app-text-input [is_required]="true" class="w-full" [label]="page_name + ' Name'" formControlName="name"></app-text-input>
            <app-text-input [is_required]="true" class="w-full" [label]="'Code'" formControlName="code"></app-text-input>
            <app-select-input [is_required]="true" label="School" class="w-full" formControlName="university_id" [options]="ds.dropdown_list?.university_list"></app-select-input>
            <app-select-input [is_required]="true" label="Level" class="w-full" formControlName="level_id" [options]="ds.dropdown_list?.level_list"></app-select-input>
            <app-text-input class="w-full" [label]="'Email'" formControlName="email"></app-text-input>
            <app-text-input type="number" class="w-full" [label]="'Contact'" formControlName="contact"></app-text-input>
        </div>
        <div class="flex justify-end items-center gap-2 mt-2">
            <app-button color="border-primary text-primary" label="Cancel" type="button" (click)="close_form_modal()"></app-button>
            <app-button color="bg-secondary text-black" [label]="selected_program_ids.id ? 'Update' :'Add'" type="button" [disabled]="isSubmitting" [submit]="submit_program.bind(this)"></app-button>
        </div>
    </form>
</app-modal>
<app-modal #bulk_modal label="Bulk Upload {{page_name | plural}}" sub_label="Add {{ page_name }} in Bulk">
    <app-bulk-upload [title]="page_name" [cancel]="bulk_modal" [accepted_type]="['.csv']" [max_file_sizeMB]="5" [bulk_columns]="bulk_columns" (submit)="bulk_upload($event.data,$event.spinner)"></app-bulk-upload>
</app-modal>

<app-modal #view_modal [label]="'View '+ page_name" width="md" (close_modal_clicked)="view_modal.close()">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">{{page_name}} Name</p>
            <p class="text-gray-900 mt-1">{{ selected_program_ids?.name || '—' }}</p>
        </div>
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">{{page_name}} Code</p>
            <p class="text-gray-900 mt-1">{{ selected_program_ids?.code || '—' }}</p>
        </div>
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">School</p>
            <p class="text-gray-900 mt-1">{{ selected_program_ids?.University?.name || '—' }}</p>
        </div>
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">Level</p>
            <p class="text-gray-900 mt-1">{{ selected_program_ids?.Level?.name || '—' }}</p>
        </div>
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">Contact Details</p>
            <p class="text-gray-900 mt-1">{{ (selected_program_ids?.contact || '') + ',' + selected_program_ids?.email||
                '—' }}
            </p>
        </div>
    </div>
</app-modal>